import m from 'mithril'
var MenuItem = {
  view: function(vnode) {
    return m('div', {class:'menu-item', onclick:vnode.attrs.onclick}, vnode.attrs.title)
  }
}


var Menu = {
  expanded: false,
  view: function(vnode) {
    var items = vnode.attrs.items
    items.map(function(item) { 
      var callback = item.onclick
      item.onclick = function() {
        vnode.state.expanded = false;
        m.redraw();
        callback();
      }
      return item;
    })

    return m("div", {class:'menu' + (vnode.state.expanded ? " expanded" : "")},
      m('div', {class:'menu-button', onclick:function() {
        vnode.state.expanded = !vnode.state.expanded
        if (!vnode.state.expanded) document.redraw();
      }}),
      m('div', {class:'menu-content'},
        items.map(function(item) { return m(MenuItem, item) }))
      );
  }
}

module.exports = Menu;